"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CustomizeField;

var _CircularProgress2 = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _InputAdornment2 = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _Grid2 = _interopRequireDefault(require("@material-ui/core/Grid"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

var _fields = _interopRequireDefault(require("../fields"));

var _icons = _interopRequireDefault(require("../icons"));

var _AutoNumber = _interopRequireDefault(require("./types/AutoNumber"));

var _Button2 = _interopRequireDefault(require("./types/Button"));

var _Checkbox = _interopRequireDefault(require("./types/Checkbox"));

var _Collaborator = _interopRequireDefault(require("./types/Collaborator"));

var _Count = _interopRequireDefault(require("./types/Count"));

var _CreatedBy = _interopRequireDefault(require("./types/CreatedBy"));

var _CreatedTime = _interopRequireDefault(require("./types/CreatedTime"));

var _Currency = _interopRequireDefault(require("./types/Currency"));

var _DateType = _interopRequireDefault(require("./types/DateType"));

var _Duration = _interopRequireDefault(require("./types/Duration"));

var _Email = _interopRequireDefault(require("./types/Email"));

var _Formula = _interopRequireDefault(require("./types/Formula"));

var _LastModifiedBy = _interopRequireDefault(require("./types/LastModifiedBy"));

var _LastModifieTime = _interopRequireDefault(require("./types/LastModifieTime"));

var _LinkToRecord = _interopRequireDefault(require("./types/LinkToRecord"));

var _Lookup = _interopRequireDefault(require("./types/Lookup"));

var _Number = _interopRequireDefault(require("./types/Number"));

var _Password = _interopRequireDefault(require("./types/Password"));

var _Percent = _interopRequireDefault(require("./types/Percent"));

var _PhoneNumber = _interopRequireDefault(require("./types/PhoneNumber"));

var _Rating = _interopRequireDefault(require("./types/Rating"));

var _SingleSelect = _interopRequireDefault(require("./types/SingleSelect"));

var _URL = _interopRequireDefault(require("./types/URL"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

CustomizeField.propTypes = {
  onClose: _propTypes["default"].func,
  onSave: _propTypes["default"].func,
  column: _propTypes["default"].object
};

function CustomizeField(_ref) {
  var _ref$column = _ref.column,
      column = _ref$column === void 0 ? {} : _ref$column,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var type = column.type,
      name = column.name,
      getStyles = column.getStyles,
      getData = column.getData,
      onSave = column.onSave;

  var defaultType = _fields["default"].find(function (item) {
    return item.value === type;
  });

  var _useState = (0, _react.useState)(name),
      _useState2 = _slicedToArray(_useState, 2),
      fieldName = _useState2[0],
      setFieldName = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultType),
      _useState6 = _slicedToArray(_useState5, 2),
      fieldType = _useState6[0],
      setFieldType = _useState6[1];

  var _useState7 = (0, _react.useState)(column.defaultValue),
      _useState8 = _slicedToArray(_useState7, 2),
      defaultValue = _useState8[0],
      setDefaultValue = _useState8[1];

  var _useState9 = (0, _react.useState)(column.options || {}),
      _useState10 = _slicedToArray(_useState9, 2),
      options = _useState10[0],
      setOptions = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      dirty = _useState12[0],
      setDirty = _useState12[1];

  var formRef = (0, _react.useRef)(null);

  var handleChangeName = function handleChangeName(e) {
    setFieldName(e.target.value);
  };

  var handleChangeType = function handleChangeType(e, newValue) {
    setFieldType(newValue);
    setDefaultValue(null);
    setDirty(true);
  };

  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e === null || e === void 0 ? void 0 : e.preventDefault();
              e === null || e === void 0 ? void 0 : e.stopPropagation();
              setLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return onSave({
                defaultValue: defaultValue,
                options: options,
                name: fieldName,
                type: fieldType === null || fieldType === void 0 ? void 0 : fieldType.value
              }, column);

            case 6:
              setLoading(false);
              onClose();
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              setLoading(false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function handleSave(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose() {
    onClose();
  };

  var optionProps = {
    dirty: dirty,
    setDefaultValue: setDefaultValue,
    defaultValue: defaultValue,
    setOptions: setOptions,
    options: options,
    getStyles: getStyles,
    getData: getData,
    style: column.style
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();

      if (fieldType.value === "linkToRecord") {
        handleSave();
      }
    }
  };

  (0, _react.useEffect)(function () {
    window.addEventListener("keydown", handleKeyDown);
    return function cleanup() {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mx: 2,
    my: 2,
    style: {
      maxWidth: 400
    }
  }, /*#__PURE__*/_react["default"].createElement("form", {
    ref: formRef,
    onSubmit: handleSave
  }, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_TextField2["default"], {
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
    },
    placeholder: "Field name (optional)",
    variant: "outlined",
    size: "small",
    name: "name",
    onClick: function onClick(e) {
      return e.target.focus();
    },
    onChange: handleChangeName,
    value: fieldName,
    autoFocus: true,
    fullWidth: true
  })), /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    id: "type",
    name: "type",
    options: _fields["default"],
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    openOnFocus: true,
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
    },
    disableClearable: true,
    blurOnSelect: true,
    value: fieldType,
    onChange: handleChangeType,
    onClick: function onClick(e) {
      return e.target.focus();
    },
    popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
        variant: "outlined",
        size: "small",
        fullWidth: true,
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment2["default"], {
            position: "start"
          }, _icons["default"][fieldType === null || fieldType === void 0 ? void 0 : fieldType.value] || _icons["default"].singleLineText)
        })
      }));
    },
    renderOption: function renderOption(option) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
        container: true,
        justifyContent: "flex-start"
      }, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
        item: true,
        style: {
          width: 30,
          textAlign: "center"
        }
      }, _icons["default"][option.value] || _icons["default"].singleLineText), /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
        variant: "body2",
        style: {
          marginLeft: "0.5rem"
        }
      }, option.name))));
    }
  }), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.desc) && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mt: 1
  }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    color: "textSecondary",
    variant: "body2"
  }, fieldType.desc))), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "singleLineText" ? /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    color: "textSecondary",
    variant: "subtitle2"
  }, "Default Text")), /*#__PURE__*/_react["default"].createElement(_TextField2["default"], {
    fullWidth: true,
    placeholder: "Enter default text",
    variant: "outlined",
    size: "small",
    name: "defaultValue",
    onClick: function onClick(e) {
      return e.target.focus();
    },
    value: defaultValue || "",
    onChange: function onChange(e) {
      return setDefaultValue(e.target.value);
    }
  })) : null, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    item: true,
    xs: 12
  }, (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "number" && /*#__PURE__*/_react["default"].createElement(_Number["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "linkToRecord" && /*#__PURE__*/_react["default"].createElement(_LinkToRecord["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "checkBox" && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "multiSelect" && /*#__PURE__*/_react["default"].createElement(_SingleSelect["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "singleSelect" && /*#__PURE__*/_react["default"].createElement(_SingleSelect["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "date" && /*#__PURE__*/_react["default"].createElement(_DateType["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "phoneNumber" && /*#__PURE__*/_react["default"].createElement(_PhoneNumber["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "email" && /*#__PURE__*/_react["default"].createElement(_Email["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "url" && /*#__PURE__*/_react["default"].createElement(_URL["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "currency" && /*#__PURE__*/_react["default"].createElement(_Currency["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "percent" && /*#__PURE__*/_react["default"].createElement(_Percent["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "duration" && /*#__PURE__*/_react["default"].createElement(_Duration["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "rating" && /*#__PURE__*/_react["default"].createElement(_Rating["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "count" && /*#__PURE__*/_react["default"].createElement(_Count["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "lookup" && /*#__PURE__*/_react["default"].createElement(_Lookup["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "createdAt" && /*#__PURE__*/_react["default"].createElement(_CreatedTime["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "updatedAt" && /*#__PURE__*/_react["default"].createElement(_LastModifieTime["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "createdBy" && /*#__PURE__*/_react["default"].createElement(_CreatedBy["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "updatedBy" && /*#__PURE__*/_react["default"].createElement(_LastModifiedBy["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "autoNumber" && /*#__PURE__*/_react["default"].createElement(_AutoNumber["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "button" && /*#__PURE__*/_react["default"].createElement(_Button2["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "password" && /*#__PURE__*/_react["default"].createElement(_Password["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "formula" && /*#__PURE__*/_react["default"].createElement(_Formula["default"], optionProps), (fieldType === null || fieldType === void 0 ? void 0 : fieldType.value) === "collaborator" && /*#__PURE__*/_react["default"].createElement(_Collaborator["default"], optionProps)), /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mt: 2
  }), /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    container: true,
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    autoCapitalize: false,
    variant: "text",
    size: "small",
    onClick: handleClose
  }, "Close"), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mr: 1
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: loading,
    variant: "contained",
    size: "small",
    type: "submit",
    color: "primary"
  }, loading ? /*#__PURE__*/_react["default"].createElement(_CircularProgress2["default"], {
    color: "inherit",
    size: 16
  }) : "Save"))))));
}